import styles from './Edit.module.scss';
import clubStyles from '../Club.module.scss';
import { TourBagBsg } from '@/api/models';
import { useEffect, useState } from 'react';
import { getBsgBallData, getBsgGloveData, getBsgGloveSizeData, getBsgHeadwearData, getBsgShoeData, getBsgShoeSizeData, getBsgShoeWidthData, getGolfBagData } from '@/service/TourBagStaticService';
import EditableDropdown, { IDropdownOption } from '@/common/EditableDropdown';
import EditableTile from '@/common/EditableTile';

interface IProps {
  closeEditForm: () => void;
  // eslint-disable-next-line no-unused-vars
  saveEditForm: (tourBag: TourBagBsg) => void;
  tourBagBsg: TourBagBsg;
}

export default function Edit({ tourBagBsg, closeEditForm, saveEditForm }: IProps) {
  const [bsgBag, setBsgBag] = useState({ ...tourBagBsg });
  const [bsgBallOptions, setBsgBallOptions] = useState([] as IDropdownOption[]);
  const [bsgGloveOptions, setBsgGloveOptions] = useState([] as IDropdownOption[]);
  const [bsgGloveSizeOptions, setBsgGloveSizeOptions] = useState([] as IDropdownOption[]);
  const [bsgHeadwearOptions, setBsgHeadwearOptions] = useState([] as IDropdownOption[]);
  const [bsgShoeOptions, setBsgShoeOptions] = useState([] as IDropdownOption[]);
  const [bsgShoeSizeOptions, setBsgShoeSizeOptions] = useState([] as IDropdownOption[]);
  const [bsgShoeWidthOptions, setBsgShoeWidthOptions] = useState([] as IDropdownOption[]);
  const [golfBagOptions, setGolfBagOptions] = useState([] as IDropdownOption[]);

  useEffect(() => {
    const loadData = async () => {
      const bsgBallData = await getBsgBallData();
      setBsgBallOptions(
        bsgBallData
          .filter((h) => !h.name.startsWith('Select'))
          .map((ball) => {
            return { id: ball.bsgBallId?.toString() ?? '', label: ball.name };
          }),
      );

      const bsgGloveData = await getBsgGloveData();
      setBsgGloveOptions(
        bsgGloveData
          .filter((h) => !h.name.startsWith('Select'))
          .map((glove) => {
            return { id: glove.bsgGloveId?.toString() ?? '', label: glove.name };
          }),
      );

      const bsgGloveSizeData = await getBsgGloveSizeData();
      setBsgGloveSizeOptions(
        bsgGloveSizeData
          .filter((h) => !h.name.startsWith('Select'))
          .map((glove) => {
            return { id: glove.bsgGloveSizeId?.toString() ?? '', label: glove.name };
          }),
      );

      const bsgHeadwearData = await getBsgHeadwearData();
      setBsgHeadwearOptions(
        bsgHeadwearData
          .filter((h) => !h.name.startsWith('Select'))
          .map((headwear) => {
            return { id: headwear.bsgHeadwearId?.toString() ?? '', label: headwear.name };
          }),
      );

      const bsgShoeData = await getBsgShoeData();
      setBsgShoeOptions(
        bsgShoeData
          .filter((h) => !h.name.startsWith('Select'))
          .map((shoe) => {
            return { id: shoe.bsgShoeId?.toString() ?? '', label: shoe.name };
          }),
      );

      const bsgShoeSizeData = await getBsgShoeSizeData();
      setBsgShoeSizeOptions(
        bsgShoeSizeData
          .filter((h) => !h.name.startsWith('Select'))
          .map((shoesize) => {
            return { id: shoesize.bsgShoeSizeId?.toString() ?? '', label: shoesize.name };
          }),
      );

      const bsgShoeWidthData = await getBsgShoeWidthData();
      setBsgShoeWidthOptions(
        bsgShoeWidthData
          .filter((h) => !h.name.startsWith('Select'))
          .map((shoeWidth) => {
            return { id: shoeWidth.bsgShoeWidthId?.toString() ?? '', label: shoeWidth.name };
          }),
      );

      const golfBagData = await getGolfBagData();
      setGolfBagOptions(
        golfBagData.map((bag) => {
          return { id: bag.golfBagId?.toString() ?? '', label: bag.name };
        }),
      );
    };
    loadData();
  }, []);

  const handleBallChange = (id: string) => {
    const ball = bsgBallOptions.find((b) => b.id?.toString() == id);
    setBsgBag({ ...bsgBag, bsgBallId: Number(id), bsgBallName: ball?.label ?? '' });
  };

  const handleGloveChange = (id: string) => {
    const glove = bsgGloveOptions.find((g) => g.id?.toString() == id);
    setBsgBag({ ...bsgBag, bsgGloveId: Number(id), bsgGloveName: glove?.label ?? '' });
  };

  const handleGloveSizeChange = (id: string) => {
    const glove = bsgGloveSizeOptions.find((g) => g.id?.toString() == id);
    setBsgBag({ ...bsgBag, bsgGloveSizeId: Number(id), bsgGloveSizeName: glove?.label ?? '' });
  };

  const handleHeadwearChange = (id: string) => {
    const headwear = bsgHeadwearOptions.find((g) => g.id?.toString() == id);
    setBsgBag({ ...bsgBag, bsgHeadwearId: Number(id), bsgHeadwearName: headwear?.label ?? '' });
  };

  const handleShoeChange = (id: string) => {
    const shoe = bsgShoeOptions.find((g) => g.id?.toString() == id);
    setBsgBag({ ...bsgBag, bsgShoeId: Number(id), bsgShoeName: shoe?.label ?? '' });
  };

  const handleShoeSizeChange = (id: string) => {
    const shoe = bsgShoeSizeOptions.find((g) => g.id.toString() == id);
    setBsgBag({ ...bsgBag, bsgShoeSizeId: Number(id), bsgShoeSizeName: shoe?.label ?? '' });
  };

  const handleShoeWidthChange = (id: string) => {
    const shoe = bsgShoeWidthOptions.find((g) => g.id?.toString() == id);
    setBsgBag({ ...bsgBag, bsgShoeWidthId: Number(id), bsgShoeWidthName: shoe?.label ?? '' });
  };

  const handleGolfBagChange = (id: string) => {
    const bag = golfBagOptions.find((b) => b.id?.toString() == id);
    setBsgBag({ ...bsgBag, golfBagId: Number(id), golfBagName: bag?.label ?? '' });
  };

  const handleInputChange = (newValue: string, field: string) => {
    setBsgBag({ ...bsgBag, [field]: newValue });
  };

  return (
    <>
      <div className={styles.fullscreen}>
        <div className={styles.form}>
          <div className={styles.row}>
            <div className={styles.categoryName}>Ball</div>
          </div>
          <div className={styles.tileRow}>
            <div className={`${styles.input}`}>
              <EditableDropdown
                label="Ball"
                initialId={bsgBag.bsgBallId?.toString() || ''}
                options={bsgBallOptions}
                onChange={(id) => handleBallChange(id)}
                className={styles.editableDropdown}
                variant="large"
                allowClear={true}
              />
            </div>
            <EditableTile label="Ball Note" value={bsgBag.bsgBallNote} onChange={(value) => handleInputChange(value, 'bsgBallNote')} variant="xxl" />
          </div>
          <div className={styles.row}>
            <div className={styles.categoryName}>Glove</div>
          </div>
          <div className={styles.tileRow}>
            <div className={`${styles.input}`}>
              <EditableDropdown
                label="Glove"
                initialId={bsgBag.bsgGloveId?.toString() || ''}
                options={bsgGloveOptions}
                onChange={(id) => handleGloveChange(id)}
                className={styles.editableDropdown}
                variant="large"
                allowClear={true}
              />
            </div>
            <EditableTile label="Glove Note" value={bsgBag.bsgGloveNote} onChange={(value) => handleInputChange(value, 'bsgGloveNote')} variant="xxl" />
            <div className={`${styles.input}`}>
              <EditableDropdown
                label="Glove Size"
                initialId={bsgBag.bsgGloveSizeId?.toString() || ''}
                options={bsgGloveSizeOptions}
                onChange={(id) => handleGloveSizeChange(id)}
                className={styles.editableDropdown}
                variant="large"
                allowClear={true}
              />
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.categoryName}>Headwear</div>
          </div>
          <div className={styles.tileRow}>
            <div className={`${styles.input}`}>
              <EditableDropdown
                label="Headwear"
                initialId={bsgBag.bsgHeadwearId?.toString() || ''}
                options={bsgHeadwearOptions}
                onChange={(id) => handleHeadwearChange(id)}
                className={styles.editableDropdown}
                variant="xxl"
                allowClear={true}
              />
            </div>
            <EditableTile label="Headwear Note" value={bsgBag.bsgHeadwearNote} onChange={(value) => handleInputChange(value, 'bsgHeadwearNote')} variant="xxl" />
          </div>
          <div className={styles.row}>
            <div className={styles.categoryName}>Shoes</div>
          </div>
          <div className={styles.tileRow}>
            <div className={`${styles.input}`}>
              <EditableDropdown
                label="Shoe"
                initialId={bsgBag.bsgShoeId?.toString() || ''}
                options={bsgShoeOptions}
                onChange={(id) => handleShoeChange(id)}
                className={styles.editableDropdown}
                variant="xxl"
                allowClear={true}
              />
            </div>
            <div className={`${styles.input}`}>
              <EditableDropdown
                label="Size"
                initialId={bsgBag.bsgShoeSizeId?.toString() || ''}
                options={bsgShoeSizeOptions}
                onChange={(id) => handleShoeSizeChange(id)}
                className={styles.editableDropdown}
                variant="extra"
                allowClear={true}
              />
            </div>
            <div className={`${styles.input}`}>
              <EditableDropdown
                label="Width"
                initialId={bsgBag.bsgShoeWidthId?.toString() || ''}
                options={bsgShoeWidthOptions}
                onChange={(id) => handleShoeWidthChange(id)}
                className={styles.editableDropdown}
                variant="extra"
                allowClear={true}
              />
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.categoryName}>Golf Bag</div>
          </div>
          <div className={styles.tileRow}>
            <div className={`${styles.input}`}>
              <EditableDropdown
                label="Bag"
                initialId={bsgBag.golfBagId?.toString() || ''}
                options={golfBagOptions}
                onChange={(id) => handleGolfBagChange(id)}
                className={styles.editableDropdown}
                variant="large"
                allowClear={true}
              />
            </div>
            <EditableTile label="Note" value={bsgBag.golfBagNotes} onChange={(value) => handleInputChange(value, 'golfBagNotes')} variant="xxl" />
            <EditableTile label="Name On Bag" value={bsgBag.nameOnBag || ''} onChange={(value) => handleInputChange(value, 'nameOnBag')} variant="xxl" />
            <EditableTile label="Logo 1" value={bsgBag.golfBagLogo1} onChange={(value) => handleInputChange(value, 'golfBagLogo1')} variant="large" />
            <EditableTile label="Logo 2" value={bsgBag.golfBagLogo2} onChange={(value) => handleInputChange(value, 'golfBagLogo2')} variant="large" />
            <EditableTile label="Logo 3" value={bsgBag.golfBagLogo3} onChange={(value) => handleInputChange(value, 'golfBagLogo3')} variant="large" />
          </div>
          <div className={styles.tileRow}>
            <div className={styles.row}>
              <div className={styles.section_header}>General Notes</div>
            </div>
            <div className={styles.row}>
              <textarea className={clubStyles.editNotes} value={bsgBag.notes} name="notes" onChange={(event) => handleInputChange(event.target.value, 'notes')} rows={5} />
            </div>
          </div>
          <div className={styles.tileRow}>
            <button className={clubStyles.saveButton} onClick={() => saveEditForm(bsgBag)}>
              Save
            </button>
            <button className={clubStyles.cancelButton} onClick={closeEditForm}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
